import { render, staticRenderFns } from "./ReportDepartures.vue?vue&type=template&id=26d40271&"
import script from "./ReportDepartures.vue?vue&type=script&lang=js&"
export * from "./ReportDepartures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports